import React from "react";
import { Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import { useSelector } from "react-redux";

export default function Loading({ text, zIndex2 = false }) {
  const classes = useStyles();
  const { openMenu } = useSelector((state) => state.menu);

  return (
    <div className={zIndex2 ? classes.loading2 : (openMenu ? classes.loading3 : classes.loading)}>
      <div className={classes.background}/>
      <img
        className={classes.icon}
        src="https://images.e-auditoria.com.br/global/gif/loading.gif"
        alt="e-Recuperador"
      />
      <div className={classes.content}>
      {text ? <Typography>{text}</Typography> : null}
      </div>
    </div>
  );
}
